module.exports = __webpack_public_path__ + "img/txyyb.e27c30ff.png";